import type { IAuthUser, IAuthUserContext } from '@/shared/types/auth-user'

/**
 * The token's `ctx` holds one element per role the user acts in; the
 * organization the request belongs to is the practitioner's.
 */
function getPractitionerContext(
  user: IAuthUser | null,
): IAuthUserContext | undefined {
  const contexts = user?.ctx ?? []
  return (
    contexts.find((context) => context.type === 'practitioner') ?? contexts[0]
  )
}

export function getOrganizationIdFromUser(user: IAuthUser | null): string {
  const organizationRef = getPractitionerContext(user)?.organization_ref
  if (!organizationRef) return ''

  const [, organizationId] = organizationRef.split('/')
  return organizationId
}

/**
 * Organization TIN — nine digits, sent bare (no `Organization/` prefix). Some
 * dictionary endpoints identify the organization by this rather than by the id
 * from `organization_ref`.
 */
export function getOrganizationTinFromUser(user: IAuthUser | null): string {
  return getPractitionerContext(user)?.organization_tin.trim() ?? ''
}
